import { Money } from '@dreryk/money-common-api';

import { TextView } from '@dreryk/react-components';
import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type AdvancePaymentRefundsTotalAmountTextViewProps = Readonly<{
   refundsTotalAmount: Money;
}>;

export const AdvancePaymentRefundsTotalAmountTextView = (
   props: AdvancePaymentRefundsTotalAmountTextViewProps
): JSX.Element => {
   return (
      <TextView testId={'advancePaymentRefundsTotalAmount'} label={translationKeys.advancePaymentRefundsTotalAmount}>
         {priceFormatter(
            props.refundsTotalAmount.asNumber(),
            getCustomFormattingContext({
               options: {
                  currency: 'PLN',
                  stripDecimalZeroes: true,
               },
            })
         )}
      </TextView>
   );
};
